import { BreadcrumbItem } from "../Components/Breadcrumb";


// Simple breadcrumb builders for your specific pages
export const createManageDomainBreadcrumbs = (
    partyName: string,
    onNavigateToParties: () => void
): BreadcrumbItem[] => {
    return [
        {
            label: 'Manage Parties',
            onClick: onNavigateToParties
        },
        {
            label: partyName,
            isActive: true
        }
    ];
};

export const createManageChannelBreadcrumbs = (
    partyName: string,
    domainName: string,
    onNavigateToParties: () => void,
    onNavigateToDomains: () => void
): BreadcrumbItem[] => {
    return [
        {
            label: 'Manage Parties',
            onClick: onNavigateToParties
        },
        {
            label: partyName,
            onClick: onNavigateToDomains
        },
        {
            label: domainName,
            isActive: true
        }
    ];
};

export const createPageBreadcrumbs = (
    pageType: 'domain' | 'channel',
    data: {
        partyName: string;
        domainName?: string;
    },
    navigation: {
        onNavigateToParties: () => void;
        onNavigateToDomains?: () => void;
    }
): BreadcrumbItem[] => {
    const breadcrumbs: BreadcrumbItem[] = [
        {
            label: 'Manage Parties',
            onClick: navigation.onNavigateToParties
        },
        {
            label: data.partyName,
            onClick: pageType === 'channel' ? navigation.onNavigateToDomains : undefined,
            isActive: pageType === 'domain'
        }
    ];

    if (pageType === 'channel' && data.domainName) {
        breadcrumbs.push({
            label: data.domainName,
            isActive: true
        });
    }

    return breadcrumbs;
};